import { ModuleContent } from '../contract';

export type ConfirmReadModuleContent = {
	moduleType: 'Checkbox' | 'Button';
	checkboxLabel: string;
	buttonLabel: string;
	goToNext: boolean;
};

export function isConfirmReadModuleContent(content: ModuleContent): content is ConfirmReadModuleContent {
	const confirmReadContent = content as Partial<ConfirmReadModuleContent>;
	return confirmReadContent.moduleType === 'Checkbox' || confirmReadContent.moduleType === 'Button';
}

export function getConfirmReadModuleIndexableText(content: ModuleContent): string {
	if (!isConfirmReadModuleContent(content)) return '';
	return [content.checkboxLabel, content.buttonLabel].filter(Boolean).join(' ').trim();
}